<template>
    <span>
        <a @click="isActive = true" style="cursor: pointer; color: #3273dc; text-decoration: underline;">
            Meer informatie&nbsp;<b-icon size="is-small" icon="info-circle" />
        </a>

        <b-modal :active.sync="isActive" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Contractondertekening vereist</p>
                </header>
                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <h4>Hoe werkt deze functie?</h4>
                    <p>Wanneer deze optie is ingeschakeld, worden contracten, facturen en betalingen automatisch op "Wacht op bevestiging" gezet totdat de klant alle contractdocumenten digitaal heeft ondertekend.</p>

                    <br>
                    <h5><strong>Wat gebeurt er bij het aanmaken van een contract?</strong></h5>
                    <ul style="margin-left: 20px;">
                        <li>Het contract krijgt de status "Wacht op bevestiging"</li>
                        <li>De klant ontvangt direct een e-mail met een unieke link om de contractdocumenten te ondertekenen</li>
                    </ul>

                    <br>
                    <h5><strong>Wat gebeurt er met facturen en betalingen?</strong></h5>
                    <ul style="margin-left: 20px;">
                        <li>Facturen krijgen de status "Wacht op bevestiging" en worden niet verzonden</li>
                        <li>Incasso betalingen worden niet gepland of uitgevoerd</li>
                        <li>Handmatige betalingen worden ook op "Wacht op bevestiging" gezet</li>
                    </ul>

                    <br>
                    <h5><strong>Wat gebeurt er na ondertekening?</strong></h5>
                    <ul style="margin-left: 20px;">
                        <li>De "Wacht op bevestiging"-status wordt automatisch opgeheven zodra <strong>alle</strong> documenten zijn ondertekend</li>
                        <li>Betalingen die op "Wacht op bevestiging" stonden worden vrijgegeven</li>
                        <li>Als de datum van inschieten incasso in het verleden ligt, wordt deze bijgewerkt naar vandaag om uitgevoerd te worden</li>
                        <li>Het normale betaalproces hervat automatisch</li>
                    </ul>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-primary" @click="isActive = false">Sluiten</b-button>
                </footer>
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    name: 'ContractSigningInfoModal',

    data() {
        return {
            isActive: false
        }
    }
}
</script>

